"use strict";
const isEmail = (email) => {
  var regex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(String(email.value.trim()).toLowerCase());
};

const showAlert = (input) => {
  let name = input.getAttribute("name");
  let invalidField = document.getElementById(`invalid-${name}`);
  invalidField.setAttribute("style", "display: block");
  input.setAttribute("style", "border: 1px solid #dc3545");
};

export const show_poll_alert = (input, message) => {
  $(input).css({ border: "1px solid rgb(183,28,28)" });
  $("#errorText").html("").append(message);
  $("#highlightError").css({ display: "block" });
  $("#modalText").html("").append(message);
  $("#errorModal").modal();
  $("#errorModal").modal("show");
};
const hideAlert = (input) => {
  let name = input.getAttribute("name");
  let invalidField = document.getElementById(`invalid-${name}`);
  invalidField.removeAttribute("style");
  input.removeAttribute("style");
};

const get_file_extension = (filename) => {
  let splitFile = filename.split(" ");
  let indexOf = splitFile.length - 1;
  let lastIndex = splitFile[indexOf];
  let findextArray = lastIndex.split(".");
  let last = findextArray.length - 1;

  return findextArray[last];
};
export async function Post_Form_Api(url, data) {
  const req = await fetch(url, {
    method: "POST",
    body: data,
  });
  const res = await req.json();
  return res;
}

export const PostFormApi = (url, data) => {
  let req = $.ajax({
    type: "POST",
    url: url,
    data: data,
    dataType: "JSON",
  });
  return req;
};

export async function Get_Form_Api(url, data) {
  const req = await fetch(url, {
    method: "GET",
    body: data,
  });
  const res = await req.json();
  return res;
}

export const getURLParams = (parameter) => {
  const queryString = window.location.search;
  const params = new URLSearchParams(queryString);
  return params.get(parameter);
};

export const validate_input_field = (input) => {
  if (
    input.getAttribute("type") == "email" ||
    input.getAttribute("name") == "email"
  ) {
    if (!isEmail(input)) {
      showAlert(input);
      return 1;
    } else {
      hideAlert(input);
      return 0;
    }
  } else {
    if (input.value.length == 0) {
      showAlert(input);
      return 1;
    } else {
      hideAlert(input);
      return 0;
    }
  }
};

export const validate_select_field = (option) => {
  let value = option.options[option.selectedIndex].value;
  if (value === 0) {
    showAlert(option);
    return 1;
  } else {
    hideAlert(option);
    return 0;
  }
};
export const compare_date_fields = () => {
  //compare the dates and validate if end date is lower than start date
  let start = document.querySelector("input[name='startDate']");
  let end = document.querySelector("input[name='endDate']");
  let start_Date = new Date(start.value);
  let end_Date = new Date(end.value);

  if (end_Date < start_Date) {
    let endDateID = end.getAttribute("name");
    let invalidDateID = document.getElementById(`invalid-${endDateID}`);
    invalidDateID.innerText = "";
    invalidDateID.innerText = "End Date cannot be less than start date";
    invalidDateID.setAttribute("style", "display: block");
    return 1;
  } else {
    return 0;
  }
};

export const getCookie = (name) => {
  // Split cookie string and get all individual name=value pairs in an array
  var cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
    if (name == cookiePair[0].trim()) {
      // Decode the cookie value and return
      return decodeURIComponent(cookiePair[1]);
    }
  }

  // Return null if not found
  return null;
};

export const formatDate = (date, format) => {
  let this_date = new Date(date);
  let this_time = this_date.getTime();
  let format_date;
  if (this_time == 0 || this_time == NaN) {
    format_date = "";
  } else {
    format_date = moment(date).format(format);
  }
  return format_date;
};

export const formatDateTimeZone = (object) => {
  let date = new Date(object.date);
  let time = date.getTime();

  let format;
  if (time == 0 || time == NaN) {
    format = "";
  } else {
    format = moment(date).tz(object.timezone).format(object.format);
  }
  return format;
};

export const formatAddress = (action) => {
  if (action.length > 0) {
    return `${action}`;
  }
  return "";
};

export const validate_file_types = (file) => {
  let valid = false;
  let file_types = [
    "pdf",
    "doc",
    "docx",
    "csv",
    "xlsx",
    "xls",
    "xlsm",
    "xlsb",
    "xltx",
    "xltm",
    "xlt",
  ];
  let file_name = file.files[0].name;
  if (file_name.length > 0) {
    let fileExtension = get_file_extension(file_name);
    file_types.forEach((x) => {
      if (fileExtension === x) {
        valid = true;
      }
    });
  } else {
    valid = false;
  }
  if (valid == false) {
    showAlert(file);
  }
  return valid;
};

export const square = () => {
  $(".square").each(function () {
    var squareWidth = $(".square").width();
    $(".square").height(squareWidth);
  });
};

export const Find_A_Clinician_Modal = (e) => {
  console.log("modal clicked");
  e.preventDefault();
  $("#findAClinicianModal").modal();
};

export const submit_response = (res) => {
  console.log(res);
  // let header_emphasis;
  // let register_more_text;
  // let program_component = document.getElementById("programs-component");
  // let thankyou_component = document.getElementById("thankyou-component");
  // if (res.success == true) {
  //   if (res.errors.length > 0) {
  //     res.errors.forEach((err) => {
  //       if (err == "no_user") {
  //         header_emphasis = document.getElementById("header_emphasis");
  //         header_emphasis.innerHTML = `We do not have you in our records`;
  //         register_more_text = document.getElementById("register_more_text");
  //         register_more_text.innerHTML = `Please use the appropriate Button to register for the program`;
  //         $("#infoModal").modal("show");
  //       }
  //     });
  //   } else {
  //     header_emphasis = document.getElementById("thank-you-header-emphasis");
  //     header_emphasis.innerHTML = `Thank you for registering, ${res.user}`;
  //     program_component.style.display = "none";
  //     thankyou_component.style.display = "block";
  //   }
  //}
};
